var React = require('react');

function IconBookmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M5 3.75C5 2.784 5.784 2 6.75 2h10.5c.966 0 1.75.784 1.75 1.75v17.5a.75.75 0 01-1.218.586L12 17.21l-5.781 4.625A.75.75 0 015 21.25V3.75zm1.75-.25a.25.25 0 00-.25.25v15.94l5.031-4.026a.75.75 0 01.938 0L17.5 19.69V3.75a.25.25 0 00-.25-.25H6.75z"}));
}

IconBookmark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor","color":"#000"};

module.exports = IconBookmark;

IconBookmark.default = IconBookmark;
